import React, { useEffect, useState } from 'react';
import { getLabAteRegressions, getLabTestspecRegressions } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabRiskBadge from '../components/LabRiskBadge';
import LabTable from '../components/LabTable';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function RegressionDetectorPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [tab, setTab] = useState('ate');
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const loader = tab === 'ate' ? getLabAteRegressions : getLabTestspecRegressions;
    loader(sharedQuery).then((data) => setRows(data.rows || []));
  }, [sharedQuery, tab]);

  return (
    <div className="lab-page">
      <LabCard
        title="Rilevatore regressioni"
        description="Confronta gruppi ATE o Testspec usando delta di fail-rate trasparenti. È logica a regole, non ML."
        actions={
          <div className="lab-tab-row">
            <button type="button" className={`lab-tab${tab === 'ate' ? ' active' : ''}`} onClick={() => setTab('ate')}>Software ATE</button>
            <button type="button" className={`lab-tab${tab === 'testspec' ? ' active' : ''}`} onClick={() => setTab('testspec')}>Testspec</button>
          </div>
        }
      >
        <LabTable
          rows={rows}
          emptyTitle="Storico insufficiente per rilevare regressioni."
          emptyDescription="Il rilevamento regressioni ha bisogno di abbastanza storico raggruppato prima che i delta siano affidabili."
          columns={[
            { key: tab === 'ate' ? 'ateVersion' : 'testspec', label: tab === 'ate' ? 'Versione ATE' : 'Testspec' },
            { key: 'totalTests', label: 'Test' },
            { key: 'failRate', label: 'Fail rate %' },
            { key: 'previousVersionOrPeriod', label: 'Gruppo precedente' },
            { key: 'deltaFailRate', label: 'Delta fail rate' },
            { key: 'topNewFailingSteps', label: 'Nuovi step critici', render: (value) => (value || []).map((item) => `${item.step} (${item.failCount})`).join(', ') || '—' },
            { key: 'severity', label: 'Severità', render: (value) => <LabRiskBadge label={value} /> },
          ]}
        />
      </LabCard>
    </div>
  );
}
